<template>
  <div class="in-stock__item">
    <div class="in-stock-card">
      <slot name="product"
            :info="info"
            :quntity="quantity"
            :link="link"
            :moduleCart="moduleCart"
      ></slot>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "ProductCard",
  props: [
    "info"
  ],
  data() {
    return {
      quantity: 1,
      link: ""
    };
  },
  computed: {
    ...mapState([
      "moduleCart"
    ]),
  },
  methods: {},
  created() {
    if (this.info.URL) {
      this.link = this.info.URL;
    }
    if (this.info.DETAIL_PAGE_URL) {
      this.link = this.info.DETAIL_PAGE_URL;
    }
  }
};
</script>